import BenchlingConfig from 'BenchlingConfig';
import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {doQuerySafe} from 'graphql-client/ApolloWrappers';
import {ACCESSIBLE_ASSAY_RUN_COUNT_ON_OVERVIEW_PAGE} from 'studies/StudyConstants';
import {
  ClinicalBasedStudyExecutionOverviewQuery,
  ClinicalBasedStudyExecutionOverviewQueryVariables,
} from 'studies/typed/clinical/__generated/ClinicalBasedStudyExecutionOverviewQuery';
import {CLINICAL_BASED_STUDY_EXECUTION_OVERVIEW_QUERY} from 'studies/typed/clinical/ClinicalStudyExecutionOverview';
import {
  MultiProcedureRunListingTableQuery,
  MultiProcedureRunListingTableQueryVariables,
} from 'studies/typed/shared/__generated/MultiProcedureRunListingTableQuery';
import {
  MultiProcedureRunStudyExecutionProgressQuery,
  MultiProcedureRunStudyExecutionProgressQueryVariables,
} from 'studies/typed/shared/__generated/MultiProcedureRunStudyExecutionProgressQuery';
import {
  ProcedureRunDetailsViewQuery,
  ProcedureRunDetailsViewQueryVariables,
} from 'studies/typed/shared/__generated/ProcedureRunDetailsViewQuery';
import {MULTI_PROCEDURE_RUN_LISTING_TABLE_QUERY} from 'studies/typed/shared/MultiProcedureRunListingTable';
import {PROCEDURE_RUN_DETAILS_VIEW_QUERY} from 'studies/typed/shared/ProcedureRunDetailsView';
import {MULTI_PROCEDURE_RUN_STUDY_EXECUTION_PROGRESS_QUERY} from 'studies/typed/shared/useMultiProcedureRunStudyProgress';
import {
  StudyOverviewViewQuery,
  StudyOverviewViewQueryVariables,
} from 'studies/workspace/overview/__generated/StudyOverviewViewQuery';
import {STUDY_OVERVIEW_VIEW_QUERY} from 'studies/workspace/overview/StudyOverviewView';

// Refresh multi-run study overview by re-running relevant query
// TODO BNCH-127205: Add query to study adapter
export async function refreshStudyOverview(studyId: string, studyType: StudyType): Promise<void> {
  const queriesToRun =
    studyType === StudyType.PROCESS_DEVELOPMENT
      ? [
          doQuerySafe<MultiProcedureRunListingTableQuery, MultiProcedureRunListingTableQueryVariables>(
            {query: MULTI_PROCEDURE_RUN_LISTING_TABLE_QUERY},
            {
              fetchPolicy: 'network-only',
              variables: {studyId, maxNumProcedureRuns: BenchlingConfig.STUDIES_MAX_NUM_RUNS_PER_PD_STUDY},
            }
          ),
          doQuerySafe<StudyOverviewViewQuery, StudyOverviewViewQueryVariables>(
            {query: STUDY_OVERVIEW_VIEW_QUERY},
            {
              fetchPolicy: 'network-only',
              variables: {id: studyId},
            }
          ),
        ]
      : [
          doQuerySafe<
            MultiProcedureRunStudyExecutionProgressQuery,
            MultiProcedureRunStudyExecutionProgressQueryVariables
          >(
            {query: MULTI_PROCEDURE_RUN_STUDY_EXECUTION_PROGRESS_QUERY},
            {
              fetchPolicy: 'network-only',
              variables: {studyId},
            }
          ),
        ];
  await Promise.all(queriesToRun);
}

// Refresh procedure run details page on multi-run studies overview
export async function refreshProcedureRunDetailsView(procedureRunId: string): Promise<void> {
  await doQuerySafe<ProcedureRunDetailsViewQuery, ProcedureRunDetailsViewQueryVariables>(
    {query: PROCEDURE_RUN_DETAILS_VIEW_QUERY},
    {
      fetchPolicy: 'network-only',
      variables: {procedureRunId},
    }
  );
}

// Refresh study overview by re-running relevant query
export async function refreshClinicalBasedStudyOverview(studyId: string): Promise<void> {
  await doQuerySafe<
    ClinicalBasedStudyExecutionOverviewQuery,
    ClinicalBasedStudyExecutionOverviewQueryVariables
  >(
    {query: CLINICAL_BASED_STUDY_EXECUTION_OVERVIEW_QUERY},
    {
      fetchPolicy: 'network-only',
      variables: {studyId, numActiveProcedureRuns: ACCESSIBLE_ASSAY_RUN_COUNT_ON_OVERVIEW_PAGE + 1},
    }
  );
}
